import { black, primary } from 'presentations/views/styles/color';
export const defaultColor = black;
export const defaultLinkColor = primary;
